import { useState } from "react";
import styled from "styled-components";
import { useAppStore } from "@/stores/appStore";
import { type_d, type_f, type_c } from "@/theme/typography";
import { on } from "events";

export default function ImageShapes({ items, type, stateKey, defaultVal }) {
	const [active, seActive] = useState(defaultVal);

	const updateState = (value, type, stateKey) => {
		const state = (prevState) => ({
			...prevState.configurator,
			[stateKey]: {
				...prevState.configurator[stateKey], // Preserve existing nested values
				...value,
			},
		});

		seActive(value);

		useAppStore.setState((prevState) => ({
			configurator: state(prevState),
		}));
	};

	return (
		<ShapeWrapper>
			{items &&
				items.map((item, i) => (
					<div
						key={i}
						onClick={() => updateState(item, type, stateKey)}
						className={`shape__item ${defaultVal.id == item.id && "is_active"}`}>
						{item.image && (
							<div className="shape__item__image">
								<img src={item.image} alt={item.title} />
							</div>
						)}
						<p className="shape__item__title" style={type_f}>
							{item.title}
						</p>
					</div>
				))}
		</ShapeWrapper>
	);
}

const ShapeWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minMax(0, 1fr));
	row-gap: 0.5rem;
	column-gap: 8px;

	& > * {
		width: 100%;
		background: #e9e1de;
		/* padding-inline: 16px;
		padding-block: 0.8rem; */
		border-radius: 5px;
	}

	.shape__item {
		display: flex;
		align-items: center;
		flex-direction: column;
		column-gap: 1rem;
		transition: background-color 98ms linear;
		cursor: pointer;
		border-radius: 5px;
		overflow: hidden;
		cursor: pointer;

		svg {
			width: 20px;
			fill: #7d6a64;
		}
	}

	.shape__item:hover {
		background-color: ${({ theme }) => theme.colors.secondary};
		color: #ffe6dc;
		transition: color 98ms linear;

		svg {
			fill: #ffe6dc;
		}

		.shape__item__title {
			color: #ffe6dc;
		}
	}

	.shape__item.is_active {
		background-color: ${({ theme }) => theme.colors.secondary};
		svg {
			fill: #ffe6dc;
		}
	}

	.shape__item__image {
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.shape__item__title {
		font-weight: 400;
		color: #7d6a64;
		padding-block: 0.5rem;
	}

	.shape__item.is_active .shape__item__title {
		font-weight: 400;
		color: #ffe6dc;
	}

	.shape__item svg.icon__x-mark {
		width: 15px;
	}
`;
